export class Importance {
  id = "";
  color = "grey lighten-2";
  description = "Undefined";
  short = "#";
  value = 0;

  constructor(data) {
    if (data instanceof Object) {
      console.assert(
        typeof data.id === "string",
        "Id as String is required",
        data
      );
      if (typeof data.id === "string") {
        this.id = data.id;
      }
      console.assert(
        typeof data.color === "string",
        "Color as String is required",
        data
      );
      if (typeof data.color === "string") {
        this.color = data.color;
      }

      console.assert(
        typeof data.description === "string",
        "Description as String is required",
        data
      );
      if (typeof data.description === "string") {
        this.description = data.description;
      }

      if (typeof data.value === "number") {
        this.value = data.value;
      } else if (typeof data.id === "string") {
        console.warn("Use ID for value");
        this.value = parseInt(data.id, 10);
      }

      if (typeof data.short === "string") {
        this.short = data.short;
      } else if (typeof data.value === "number" && !isNaN(this.value)) {
        this.short = data.value.toString();
      }

      if (isNaN(this.value)) {
        this.value = 0;
      }
    }
  }
}
